import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'
import { i18nTranslationHelper } from '@/i18n'

const t = {
  validations: i18nTranslationHelper.getTValidations
}

const RgRneFormatPattern: DocumentFormatPattern<RegExp> = {
  normalize: (value: string) => value.trim(),
  mask: /^[\w|.-]{0,30}$/,
  prepareChar: str => str.toUpperCase(),
  placeholder: '000000000',
  blocks: {},
  validate: (value?: string): boolean => {
    if (!value || value.length < 5) return false
    return RgRneFormatPattern.mask.test(value)
  },
  isValid: (value?: string): boolean => {
    return RgRneFormatPattern.validate?.(value) === true
  },
  rules: {
    minLength: {
      value: 5,
      message: t.validations('minLength', { minChars: '5' })
    },
    maxLength: {
      value: 30,
      message: t.validations('maxLength', { maxChars: '30' })
    }
  }
}
export default RgRneFormatPattern
